// extracted by mini-css-extract-plugin
export default {"overflowVisible":"style_overflowVisible__wYTy4"};